import React from "react";
import { Layout, Row, Col } from "antd";
const { Footer } = Layout;

const FooterComponent = () => {
  const copyrightText = "ERSTER FRANKFURTER SCHWIMM CLUB 1891 e.V.";

  return (
    <Footer style={{ textAlign: "center" }}>
      <a href="#">
        <img
          alt="mmgy-logo"
          className="footer-logo"
          src={process.env.PUBLIC_URL + "/assets/Logo.png"}
        />
      </a>
      {copyrightText}
    </Footer>
  );
};

export default FooterComponent;
